import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import dialog from '@/utils/dialog'
import createRouter from './createRouter'

import {
  nextStep,
  applyLessonTime
} from '@/api/base'
import {
  getUserLocalData
} from '@/utils/auth'

import {
  Message
} from 'element-ui'

Vue.use(Vuex)
let lastCb
const store = new Vuex.Store({
  state: {
    module: {
      moduleType: '',
      moduleName: '',
      goalType: 1, //对应关系找产品要
    },
    topic: {
      topicId: '',
      topicName: '',
    },
    isLoading: false,
    answerTime: 0,
    questionId: '',
    stopTimer: false, //  是否執行跳過操作 提交答案時 暫停用時
    pkgMsg: '',
    moduleInfo: {}, // 模块信息
    knowledgeInfo: {}, // 知识点信息
    learnInfo: {}, //
    source: {}, // 页面数据
    component: {}, // 模块切换信息,
    choosedOptions: [], // 选中的选项
    gameData: {}, // 游戏数据
    activity: {}, //
    autoRobot:!1,  //自动答题机器人
    crtstalNum: 0,  //水晶数量
    studyBeatArea: {}, // 同步课打地基
    userSubmitIsNeedAlert: false, 
  },
  mutations: {
    NEXT_STEP: (state, data) => {
      const { moduleInfo, knowledgeInfo, learnInfo, source, activity,studyBeatArea,userSubmitIsNeedAlert } = data.res.data
      state.activity = activity;
      state.knowledgeInfo = knowledgeInfo;
      state.learnInfo = learnInfo;
      state.source = source;
      state.moduleInfo = moduleInfo || {};
      // 同步课 用户在1小时内 做题数 小于10题时
      state.studyBeatArea = studyBeatArea; // 做题数量
      state.userSubmitIsNeedAlert = userSubmitIsNeedAlert; // 是否需要弹框
      state.component = createRouter(data.res.data, data.to);
    },
    SET_SOURCE: (state, data) => {
      state.source = data
    },
    SET_LOADING: (state, data) => {
      state.isLoading = data
    },
    SET_OPTIONS: (state, data) => {
      state.choosedOptions = data
    },
    SET_ANSWER_TIME: (state, data) => {
      state.answerTime = data
    },
    SET_QUESTION_ID: (state, data) => {
      state.questionId = data
    },
    SET_STOP_TIMER: (state, data) => {
      state.stopTimer = data
    },
    UPDATE_PKG_MSG: (state, data) => {
      state.pkgMsg = data
    },
    SET_GAME_DATA: (state, data) => {
      console.log(data,'game data');
      state.gameData = data
    },
    // 设置自动答题机器人
    SET_AUTO_ROBOT: (state, data) => {
      state.autoRobot = data
    },
    //获取水晶数
    GET_CRASTAL_NUM: (state, data) => {
      state.crtstalNum = data
    }
  },
  actions: {
    nextStep({ dispatch, commit }, { is_continue, cb, to } = { is_continue: 0 }) {
      return new Promise(async (resolve, reject) => {
        let { user_id, course_id } = getUserLocalData()
        let res
        if (typeof cb != 'undefined') {
          lastCb = cb
        }
        try {
          if (is_continue) {
            res = await nextStep({ is_continue })
          } else {
            res = await nextStep({})
          }
        } catch (e) {
          Message({
            message: e.msg,
            type: 'error',
            duration: 3000
          })
          reject(e)
          return
        }

        if(res.code !== 200){
          Message({
            message: res.msg,
            type: 'error',
            duration: 3000
          })
          resolve(res)
        }
        const code = res.code
        const pkgCode = res.data.courseHourData && res.data.courseHourData.code || 200
        if (code === 200 && pkgCode === 200) {
          if (code === 200) {
            commit('NEXT_STEP', { res, to })
            resolve(res)
          }

          if (pkgCode !== 200) {
            const pkgData = res.data.courseHourData.data
            const pkgMsg = res.data.courseHourData.msg

            let opts = {}
            if (pkgCode === 8930003) {
              opts = {
                onSure: () => dispatch('nextStep', { is_continue: 1 }).then(r => {
                  if (r.code === 200 && r.data.courseHourData.code === 200){
                    lastCb();
                  }
                }),
                msg: pkgMsg
              }
            }

            if (pkgCode === 8930004) {
              commit('UPDATE_PKG_MSG', pkgMsg)
              const timeList = pkgData.applyTimes
              const remark = pkgData.remark
              const params = {
                user_id,
                course_id
              }
              opts = {
                onSure: () => dispatch('applyLessonTime', params).then(() => {
                  dispatch('nextStep').then(r => {
                    if (r.code === 200 && r.data.courseHourData.code === 200) {
                      lastCb()
                    }
                  })
                }),
                timeList,
                msg: pkgMsg,
                remark
              }
            }

            if (pkgCode === 8930005 || pkgCode === 8930006) {

              opts = {
                onSure: () => dispatch('nextStep').then(r => {
                  if (r.code === 200 && r.data.courseHourData.code === 200) {
                    lastCb()
                  }
                }),
                msg: pkgMsg
              }
            }

            if (pkgCode === 8930007) {
              opts = {
                onSure: () => {
                  const params = {
                    user_id,
                    course_id
                  }
                  const timeList = pkgData.applyTimes
                  const msg = store.state.pkgMsg
                  const remark = pkgData.remark

                  dialog.init(8930004, {
                    onSure: () => dispatch('applyLessonTime', params).then(() => {
                      dispatch('nextStep').then(r => {
                        if (r.code === 200 && r.data.courseHourData.code === 200) {
                          lastCb()
                        }
                      })
                    }),
                    timeList,
                    msg,
                    remark,
                    reChoose: 1
                  })
                },
                msg: pkgMsg
              }
            }
            dialog.init(pkgCode, opts)

            resolve({code: pkgCode})
          }
        }
      })
    },
    applyLessonTime({ dispatch, commit }, data) {
      return new Promise(async(resolve, reject) => {
        const radio = $('.sq-dialog-times-list input[name="radio"]:checked')

        if (radio) {
          const time = radio.attr('data-value')
          const params = Object.assign({}, data, {
            time_length: parseInt(time)
          })

          let res
          try {
            res = await applyLessonTime(params)
          }catch(e){
            // showErrMessage(e, '申请课时失败!')
            reject()
            return
          }

          if (res.code === 200) {
            resolve()
          }else{
            reject()
          }
        }
      })
    },
    setSource({ commit }, data) {
      commit('SET_SOURCE', data)
    },
    setLoading({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', data)
        resolve()
      })
    },
    setOptions({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_OPTIONS', data)
        resolve()
      })
    },
    setAnswerTime({
      commit
    }, data) {
      commit('SET_ANSWER_TIME', data)
    },
    stopTimer({
      commit
    }, data) {
      commit('SET_STOP_TIMER', data)
    },
    setQuestionid({
      commit
    }, data) {
      commit('SET_QUESTION_ID', data)
    },
    setTimeoutNotice({
      commit
    }, data) {
      commit('SET_TIMEOUT_NOTICE', data)
    },
    setTimeoutNotice({
      commit
    }, data) {
      commit('SET_TIMEOUT_NOTICE', data)
    },
    setGameData({
      commit
    }, data) {
      commit('SET_GAME_DATA', data)
    },
    // 设置自动答题机器人
    setAutoRobot({ 
      commit
     }, data) {
      commit('SET_AUTO_ROBOT', data)
    },
    setCrastalNum({
      commit
    }, data){
      commit('GET_CRASTAL_NUM', data)
    }
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js